import _ from "underscore";
import moment from "moment";

// adjustStartDateForAggregation
// isolateTopicLine

export const adjustStartDateForAggregation = (params) => {
	const { startDate, aggregationLevel } = params;

	if (!startDate) {
		return Number(
			moment()
				.subtract(2, "years")
				.format("x")
		);
	} else if (!aggregationLevel) {
		return startDate;
	} else if (aggregationLevel === "weeklyTimeseries") {
		return Number(startDate) - 86400000 * 6;
	} else if (aggregationLevel === "monthlyTimeseries") {
		return Number(startDate) - 86400000 * 29;
	} else {
		return startDate;
	}
};

// Returns the id (string) of the topic to isolate, or false
export const isolateTopicLine = (params) => {
	const { lines } = params;

	// Don't isolate a single line
	if (!lines || lines.length < 2) {
		return false;
	}

	const groupedByParent = _.groupBy(lines, "parent"); // returns an object
	const parents = groupedByParent && Object.keys(groupedByParent);
	// Only isolate a single
	if (!parents || parents.length !== 2) {
		return false;
	}

	// ---- Expected data structure at this point ----
	// topicId is the topic (what we want to return)
	// parents = [topicId, narratives] // always length 2 at this point
	// groupedByParent = {
	// 	topicId: [ // doesn't matter how many are in this group - just match the first object's parent
	// 		{ id: narId1, parent: topicId },
	// 		{ id: narId2, parent: topicId },
	// 	],
	// 	narratives: [
	// 		{ id: topicId, parent: narratives },
	// 	]
	// }

	// Find the id that is the parent of the others.
	const idOne = parents[0];
	const idTwo = parents[1];
	const topicId =
		groupedByParent[idOne][0].id === idTwo
			? idTwo
			: groupedByParent[idTwo][0].id === idOne ? idOne : false;

	// Make sure there is only one line in the topic group
	const topicsParentId = topicId === idOne ? idTwo : idOne; // The Topic's parent id is the other id
	if (groupedByParent[topicsParentId].length !== 1) {
		return false;
	}

	return topicId;
};

// // ------ Quokka.js test ------
// const arr = [
// 	{ id: "topicId", parent: "narratives" },
// 	// { id: "narId1", parent: "topicId" },
// 	// { id: "narId2", parent: "topicId" },
// 	// { id: "randomId2", parent: "otherTopicId" },
// 	{ id: "topicId2", parent: "narratives" },
// 	{ id: "topicId3", parent: "narratives" },
// 	{ id: "topicId4", parent: "narratives" },
// 	{ id: "topicId5", parent: "narratives" },
// 	// { id: "narId3", parent: "topicId2" },
// ];
// console.log(isolateTopicLine({ lines: arr }));
